module.exports = __webpack_public_path__ + "media/images/emoticons/eight-efb5bf09a07320ba47c3a8698c6fac28.gif";